import { Box, Button, Icon, Input, Spacer } from "@chakra-ui/react";
import { FiCheck, FiFile } from "react-icons/fi";
import { WithTranslation, withTranslation } from "react-i18next";
import React from "react";

/**
 * Interface for the file upload arguments.
 *
 * @interface
 * @augments {WithTranslation}
 */
interface FileUploadArguments extends WithTranslation 
{
  /**
   * The event handler to handle a file selection.
   *
   * @property {any} handleSelected The event handler to handle a file selection.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSelected: any;

  /**
   * A value indicating whether the component is disabled or not.
   *
   * @property {any} disabled A value indicating whether the component is disabled or not.
   */
  disabled: boolean;
}

/**
 * Interface for the file upload.
 *
 * @interface
 */
interface FileUploadState 
{
  /**
   * A value indicating whether a file has been selected.
   *
   * @property {boolean} selected A value indicating whether a file has been selected.
   */
  selected: boolean;
}

/**
 * The file upload.
 *
 * @class
 * @augments {React.Component<FileUploadArguments, FileUploadState>}
 */
class FileUpload extends React.Component<FileUploadArguments, FileUploadState> 
{
  /**
   * The input reference.
   *
   * @property {any} inputRef The input reference.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputRef: any;

  /**
   * Create an instance of file upload.
   *
   * @class
   * @param {FileUploadArguments} props The properties
   * @returns {FileUpload} A file upload component instance.
   */
  constructor(props: FileUploadArguments) 
  {
    super(props);

    this.inputRef = React.createRef();

    this.state = {
      selected: false,
    };
  }

  /**
   * Handle a click.
   *
   * @returns {void}
   */
  handleClick() 
  {
    this.setState({
      selected: false,
    });

    this.inputRef.current.click();
  }

  /**
   * Handle a file change.
   *
   * @param {any} event The event.
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleFileChange(event: any) 
  {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) 
    {
      this.setState({
        selected: false,
      });

      return;
    }

    this.setState({
      selected: true,
    });

    event.target.value = null;

    this.props.handleSelected(fileObj);
  }

  /**
   * Render the component.
   *
   * @returns {JSX.Element} The component instance.
   */
  render() 
  {
    return (
      <Box display={"flex"}>
        <Input
          style={{ display: "none" }}
          ref={this.inputRef}
          type="file"
          onChange={this.handleFileChange}
        />
        <Spacer />
        <Button
          disabled={this.props.disabled}
          leftIcon={
            this.state.selected ? <Icon as={FiCheck} /> : <Icon as={FiFile} />
          }
          onClick={this.handleClick}
        >
          Datei auswählen
        </Button>
        <Spacer />
      </Box>
    );
  }
}

export default withTranslation()(FileUpload);